'use client'; 
import React from "react";
import FooterText from "./footerText";
import SocialComp from "./socialComp";
import NewsLetterComp from "./newsletterComp";
//import Link from "next/link";
//import HeroSection from "./workshophero";

const Footer = () => {
  return (
    <div className="bg-[var(--bg-surface)] pt-5">



     
     
      {/* Newsletter Subscription */}
      <NewsLetterComp
        heading="Join our newsletter"
        text="Seasonal recipes, practical health notes, and the occasional offer."
      />

      {/* Social Icons and Footer Text */}
      <div className="flex flex-col items-center justify-center mt-4 rounded">
        {/* Social Icons */}
        <div className="mb-4">
          <SocialComp />
        </div>

        {/* Footer Text */}
        <FooterText />
      </div>
    </div>
  );
};

export default Footer;